module.exports = __webpack_public_path__ + "img/tr.2254e9c0.svg";